import createCache from '@emotion/cache';
/**
 * Emotion cache creator with default settings.
 */
export const createEmbedEmotionCache = (options) => createCache({
    key: 'fwn',
    speedy: true,
    ...options,
});
